import { useSearchParams } from 'react-router-dom';

// 목록 필터 값을 주소(?param=)에 두고 읽고 쓴다. 상세에서 돌아와도 필터가 유지된다.
// options에 없는 값이면 'all'로 보고, 'all'을 고르면 파라미터를 지운다.
export default function useSearchFilter(param, options) {
    const [searchParams, setSearchParams] = useSearchParams();
    const raw = searchParams.get(param);
    const value = options.some(item => item.key === raw) ? raw : 'all';
    const setValue = key => setSearchParams(key === 'all' ? {} : { [param]: key });
    return [value, setValue];
}
